import React, { useEffect, useState } from "react";
import Select from "react-select";

import { useDispatch } from "react-redux";

import { Button } from "@wac-ui-dashboard/wac_component_library";
import { getAllFranchises, getAllIsConfirmed } from "../../../../store/slices/customers/registerCustomersSlice";
const PurchaseFilterForm = ({ formik, handleResetExtraFilters }) => {
  const dispatch = useDispatch();
  const [franchiseOptions, setFranchise] = useState([]);
  const [isConfirmedOptions, setisConfirmed] = useState([]);

  useEffect(() => {
    dispatch(getAllFranchises())
      .unwrap()
      .then((result) => {
        setFranchise(
          result.data.data?.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
      })
      .catch((err) => {});


      dispatch(getAllIsConfirmed())
      .unwrap()
      .then((result) => {
        setisConfirmed(
          result.data.data?.map((item) => ({
            label: item.value,
            value: item.id,
          }))
        );
      })
      .catch((err) => {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {/* Render form fields for the "Basic" tab */}

      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Franchise
          </label>
          <Select
            name="franchise"
            options={franchiseOptions} // replace with your franchise options
            onChange={(selectedOption) =>
              formik.setFieldValue("franchise", selectedOption)
            }
            className={`pro-input lg ${
              formik.errors.franchise && formik.touched.franchise && "error"
            }`}
            classNamePrefix={`pro-input`}
            onBlur={formik.handleBlur}
            value={formik.values.franchise}
          />
          {formik.touched.franchise && formik.errors.franchise && (
            <div className="error">{formik.errors.franchise}</div>
          )}
        </div>
      </div>
      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Is Confirmed
          </label>
          <Select
            name="franchise"
            options={isConfirmedOptions} // replace with your franchise options
            onChange={(selectedOption) =>
              formik.setFieldValue("isConfirmed", selectedOption)
            }
            className={`pro-input lg ${
              formik.errors.isConfirmed && formik.touched.isConfirmed && "error"
            }`}
            classNamePrefix={`pro-input`}
            onBlur={formik.handleBlur}
            value={formik.values.isConfirmed}
          />
          {formik.touched.isConfirmed && formik.errors.isConfirmed && (
            <div className="error">{formik.errors.isConfirmed}</div>
          )}
        </div>
      </div>

      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Start Date
          </label>
          <input
            type="date"
            name="startDate"
            placeholder="Date of Birth"
            onChange={formik.handleChange}
            className={`pro-input lg ${
              formik.errors.startDate && formik.touched.startDate && "error"
            }`}
            onBlur={formik.handleBlur}
            value={formik.values.startDate}
          />
          {formik.touched.startDate && formik.errors.startDate && (
            <div className="error">{formik.errors.startDate}</div>
          )}
        </div>
      </div>

      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            End Date
          </label>
          <input
            type="date"
            name="endDate"
            placeholder="Date of Birth"
            onChange={formik.handleChange}
            className={`pro-input lg ${
              formik.errors.endDate && formik.touched.endDate && "error"
            }`}
            onBlur={formik.handleBlur}
            value={formik.values.endDate}
            min={formik?.values?.startDate ? formik.values.startDate : ""}
          />
          {formik.touched.endDate && formik.errors.endDate && (
            <div className="error">{formik.errors.endDate}</div>
          )}
        </div>
      </div>

      <div
        className={`col-12 pro-d-flex pro-justify-end  "offcanvas-footer-sticky-btns"
        }`}
      >
        <Button
          className={"pro-btn-link lg pro-px-3"}
          onClick={handleResetExtraFilters}
        >
          Reset
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
          type="submit"
          disabled={false}
          onClick={formik.handleSubmit}
        >
          Filter
        </Button>
      </div>
    </div>
  );
};

export default PurchaseFilterForm;
